<script>
  export let columns = { id0: "Heading" };
  export let rowData = [{ id0: "Data" }];

  function markNextStop(row) {
    let highlightRow = false;
    for (let [key, value] of Object.entries(columns)) {
      if (row[key] !== undefined) {
        if (row[key].includes("Arriving") || row[key].includes("> 1 min"))
          highlightRow = true;
      }
    }
    return highlightRow ? "next-stop" : "";
  }
</script>

<style>
  .next-stop {
    background-color: aquamarine;
    color: black;
  }
</style>

<table>
  <thead>
    <tr>
      {#each Object.entries(columns) as [key, value], i}
        <th class={'th' + key}>{value}</th>
      {/each}
    </tr>
  </thead>
  <tbody>
    {#each rowData as row}
      <tr class={markNextStop(row)}>
        {#each Object.entries(columns) as [key, value], i}
          <td class={'td' + key}>
            {@html row[key] !== undefined ? row[key] : ''}
          </td>
        {/each}
      </tr>
    {/each}
  </tbody>
</table>
